import { render, staticRenderFns } from "./downformModel.vue?vue&type=template&id=5b4cab10&scoped=true&"
import script from "./downformModel.vue?vue&type=script&lang=js&"
export * from "./downformModel.vue?vue&type=script&lang=js&"
import style0 from "./downformModel.vue?vue&type=style&index=0&id=5b4cab10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4cab10",
  null
  
)

export default component.exports